<c-row>
    <c-col xs="12">
      <c-card class="mb-4 shadow">
        <c-card-header ngPreserveWhitespaces>
          <c-row>
            <c-col>
              <strong>Invoices</strong>
            </c-col>
          </c-row>
        </c-card-header>
        <c-card-body>
          <c-col xs="12">
            <app-InvoiceHistoryTable
            [UserData]="UserData"
          ></app-InvoiceHistoryTable>
          </c-col>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
  